import { Icon, Logo } from '@livable/saas-react-components';
import { AppBar, IconButton, Toolbar, Typography } from '@mui/material';
import React from 'react';
import HeaderSearch from 'src/components/general/HeaderSearch';
import HeaderVideoButton from 'src/components/general/HeaderVideoButton';
import { ProfileMenu } from 'src/components/layout/ProfileMenu';
import HeaderNotifications from 'src/components/shared/HeaderNotifications';
import useStyles from './styles';
export function BasicHeader(props) {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(AppBar, {
    "data-tut": "reactour__top-nav"
  }, /*#__PURE__*/React.createElement(Toolbar, {
    className: classes.basicHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.basicLogoWrapper
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "sidebar-menu",
    onClick: props.toggleSidebar
  }, /*#__PURE__*/React.createElement(Icon, {
    pattern: "gradient",
    type: "menu"
  })), /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement("div", {
    className: "header-buttons"
  }, /*#__PURE__*/React.createElement(HeaderVideoButton, null), /*#__PURE__*/React.createElement(HeaderNotifications, null), /*#__PURE__*/React.createElement(ProfileMenu, null))));
}

// TODO: TO be deleted we have reactive component but keeping because it's used for our guide
export function SearchHeader(props) {
  return /*#__PURE__*/React.createElement(AppBar, null, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "sidebar-menu",
    onClick: props.toggleSidebar
  }, /*#__PURE__*/React.createElement(Icon, {
    pattern: "gradient",
    type: "menu"
  })), /*#__PURE__*/React.createElement(Logo, {
    to: "/active_dashboard"
  }), /*#__PURE__*/React.createElement(HeaderSearch, null), /*#__PURE__*/React.createElement("div", {
    className: "header-buttons"
  }, /*#__PURE__*/React.createElement(ProfileMenu, null))));
}
export function WelcomeHeader() {
  return /*#__PURE__*/React.createElement(AppBar, null, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(Logo, null), /*#__PURE__*/React.createElement("div", {
    className: "status-bar"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Welcome home, Kristin")), /*#__PURE__*/React.createElement("div", {
    className: "header-buttons"
  }, /*#__PURE__*/React.createElement(HeaderNotifications, null), /*#__PURE__*/React.createElement(ProfileMenu, null))));
}